import { EventBus } from 'quasar'

import type { LocalesCode } from 'src/i18n/locales'
import type {
  ColumnsOnlyReferences,
  RuleEditorColumn,
  RuleEditorPowerFunction,
} from 'types/common/rulesEditor/ruleEditor'

const bus = new EventBus<{
  // COMMON
  // Rule Editor
  'update:customFields': (
    customFields: RuleEditorColumn[],
    removeCustomField?: RuleEditorColumn
  ) => void
  'update:customFieldUsage': (
    columnName: string,
    type: 'add' | 'remove'
  ) => void
  'update:powerFunction': (powerFunction: RuleEditorPowerFunction) => void
  'update:references': (
    references: Partial<Record<keyof ColumnsOnlyReferences, RuleEditorColumn[]>>
  ) => void
  'update:enabled': (enabled: boolean) => void
  'update:canSave': (canSave: boolean) => void
  // Locale
  changeLocale: (locale: LocalesCode) => void
  // SENDER
  updateSolutions: () => void
  // RECEIVER
  updateEmailInvitations: () => void
}>()

export const useEventBus = () => {
  return { bus }
}
